import apiClient from '../apiClient';
import { apiBaseUrl } from '../../config';

export const getGeneralBalance = async (start, end) => {
    return apiClient.get(`${apiBaseUrl}/collection/portfolio/balance/${start}/${end}`)
        .then(response => { return response })
}

export const getPortfolioClients = async (start, end, page = 1, limit = 10, search = "", filters = "", sort = "") => {
    const escapedSearch = encodeURIComponent(search);
    var wildcard = escapedSearch != "null" ? "wildCard~" + escapedSearch : ""
    return apiClient.get(`${apiBaseUrl}/collection/portfolio/clients/${start}/${end}?page=${page}&limit=${limit}&q=${wildcard}${filters || ''}&${sort || 'field=created&order=-1'}`)
        .then(response => { return response })
}

export const getServicesDebt = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/collection/payment-link/${accountId}`)
        .then(response => { return response })
}

export const getTimeline = async (accountId, year) => {
    return apiClient.get(`${apiBaseUrl}/collection/timeline/${accountId}?year=${year}`, {})
        .then(response => { return response })
}

export const getTimelineYears = async (contractId) => {
    return apiClient.get(`${apiBaseUrl}/collection/timeline/years/${contractId}`)
    .then(response => { return response })
}

export const getAditionalServices = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/collection/service/${accountId}`,{})
        .then(response => { return response })
}

export const getCollectioClient = async (accountId) => {
    return apiClient.get(`${apiBaseUrl}/collection/portfolio/client/${accountId}`,{})
        .then(response => { return response })
}

export const reportServicePayment = async (serviceId, date, amount) => {
    return apiClient.put(`${apiBaseUrl}/taxpayer-account/service/${serviceId}`, {
        "payment_date": date,
        "payment_amount": amount
    })
        .then(response => { return response })
}

